var exports = {
  "rb": "AccountRestrictionScreen.module__selectable___eE9iMG",
  "wE": "AccountRestrictionScreen.module__directionScope___eE9iMG",
  "v5": "AccountRestrictionScreen.module__dialogBody___eE9iMG",
  "kL": "AccountRestrictionScreen.module__container___eE9iMG",
  "MT": "AccountRestrictionScreen.module__surface___eE9iMG",
  "qr": "AccountRestrictionScreen.module__footer___eE9iMG",
  "DD": "AccountRestrictionScreen.module__title___eE9iMG",
  "uW": "AccountRestrictionScreen.module__section___eE9iMG",
  "R_": "AccountRestrictionScreen.module__heading___eE9iMG",
  "z": "AccountRestrictionScreen.module__summary___eE9iMG",
  "Qq": "AccountRestrictionScreen.module__text___eE9iMG",
  "Cb": "AccountRestrictionScreen.module__fineText___eE9iMG",
  "ir": "AccountRestrictionScreen.module__reference___eE9iMG",
};

module.exports = exports;
